import type { HsShaderObjectType } from '../enums/shader-object-type.enum';
import { HsShader2D } from './shader-2d.class';

export class HsShaderData2D {
  private readonly fragmentFields: string[] = [];
  private readonly fragmentFunctions: string[] = [];
  private readonly fragmentMain: string[] = [];

  private readonly shader: HsShader2D;

  constructor(shaderType: HsShaderObjectType) {
    this.shader = new HsShader2D(shaderType);
  }

  public addTexture(): HsShaderData2D {
    this.fragmentFields.push('uniform sampler2D u_texture;');
    this.fragmentMain.push('vec4 textureColor = texture(u_texture, v_texcoord);');
    this.fragmentMain.push('color.rgb += textureColor.rgb;');
    this.fragmentMain.push('color.a *= textureColor.a;');
    return this;
  }

  public addBackground(): HsShaderData2D {
    this.fragmentFields.push('uniform mat3 rotation');
    this.fragmentMain.push(`
      float height = rd.y * 0.5 + 0.5;
      vec3 sky = vec3(0.6, 0.8, 1.0) * 4.0;
      vec3 sunColor = vec3(1.0, 0.75, 0.5) * 6.0;
      vec3 sunDir = normalize(vec3(1.0, 1.0, 1.0));
      sky += pow(max(dot(rd, sunDir), 0.0), 2.0) * sunColor;
      vec3 horizon = vec3(1.0, 1.0, 1.0);
      vec3 ground = vec3(0.8, 0.75, 0.65);
      float skyGradient = smoothstep(0.7, 0.4, height);
      float groundGradient = smoothstep(0.5, 0.3, height);
      vec3 color = mix(sky, horizon, skyGradient);
      color = mix(color, ground, groundGradient);
    `);
    return this;
  }

  public makeShader(): HsShader2D {
    this.shader.makeVertexCode = () => `#version 300 es
    in vec2 a_position;
    in vec2 a_texcoord;

    uniform vec4 u_transform;

    out vec2 v_texcoord;
    
    void main() {
        v_texcoord = a_texcoord;
        vec2 position = a_position * u_transform.xy + u_transform.zw;
        gl_Position = vec4(position, 0.0, 1.0);
    }`;

    this.shader.makeFragmentCode = () => `#version 300 es
      precision highp float;

      in vec2 v_texcoord;

      layout(location = 0) out vec4 fragmentColor;

      ${this.fragmentFields.join('\n')}

      ${this.fragmentFunctions.join('\n')}

    void main() {
        vec4 color = vec4(0.0, 0.0, 0.0, 1.0);
        ${this.fragmentMain.join('\n')}
        fragmentColor = color;
    }
      `;
    return this.shader;
  }
}
